import { ICruiseSearchFacets } from '@interfaces/cruise';
import { IRequestType } from '@interfaces/request';
import React from 'react';
import { IGetLandingPage, IModulesData } from '../../../../../interfaces';

import { getDetectedDevice } from '../../../utils/device-detection';
import { numberFormat, replaceVal } from '../../../utils/formatting';
import { __ } from '../../../utils/translation-service';
import { DreamlinesButton } from '../../atoms/dreamlines-button/dreamlines-button';
import { NextImage } from '../../atoms/image/image';
import { CruiseSearchMask } from '../../molecules/cruise-search-mask/cruise-search-mask';
import { FrontpageStage } from '../frontpage-stage/frontpage-stage';
import {
    StyledBgWrapper,
    StyledCompanyLogo,
    StyledCompanyLogoWrapper,
    StyledContentWrapper,
    StyledCustomButtonWrapper,
    StyledOverlay,
    StyledSection,
    StyledStageWrapper,
} from './landingpage-stage-search.style';
import { getAssetsPrefix } from '../../../utils/buildVersion';
import { IPageProps } from 'interfaces/IPages';

export interface ILandingpageStageProps {
    companyImage: string;
    title: string;
    backgroundImage: string;
    totalSearchResultCount?: number;
    highestDiscount?: number;
    type: IRequestType;
    onSearchSubmit: () => void;
    cruiseSearchFacets: ICruiseSearchFacets;
    pageTypeId: number;
    landingPage?: IGetLandingPage;
    modulesData?: IModulesData;
    pageProps: IPageProps;
}

const getCruiseStage = (
    title: string,
    cruiseSearchFacets: ICruiseSearchFacets,
    type: string,
    pageTypeId: number,
    pageProps: IPageProps,
) => {
    return (
        <CruiseSearchMask
            preHeadline=""
            headline={title}
            type={type}
            pageTypeId={pageTypeId}
            cruiseSearchFacets={cruiseSearchFacets}
            showBadge={false}
            showUSP={false}
            containerMargin="0"
            pageProps={pageProps}
        />
    );
};

const LandingpageStageSearch = (
    {
        companyImage,
        title,
        backgroundImage,
        totalSearchResultCount,
        highestDiscount,
        type,
        onSearchSubmit,
        cruiseSearchFacets,
        pageTypeId,
        pageProps,
    }: ILandingpageStageProps,
    ref: React.Ref<HTMLElement | null>,
) => {
    const device = getDetectedDevice();
    const assetPrefix = getAssetsPrefix();
    const stageBackgroundFallback = `${assetPrefix}/static/images/ship-fallback-bg.jpg`;

    const totalCount = totalSearchResultCount;

    const formattedOfferCount =
        totalCount && totalCount > 0 && replaceVal(__('seeAllOffers'), numberFormat(totalCount));

    return (
        <>
            {device === 'mobile' ? (
                <StyledStageWrapper ref={ref} removePadding={true}>
                    <FrontpageStage backgroundImage="color">
                        {getCruiseStage(title, cruiseSearchFacets, type, pageTypeId, pageProps)}
                    </FrontpageStage>
                </StyledStageWrapper>
            ) : (
                <StyledSection ref={ref} data-testid="landingpage-stage">
                    <StyledBgWrapper>
                        <NextImage
                            fill
                            placeholder=""
                            imgUrl={backgroundImage || stageBackgroundFallback}
                            isBackground
                            priority={true}
                            customContentStyle={{
                                height: '100%',
                            }}
                            style={{
                                objectFit: 'cover',
                            }}
                        >
                            <StyledOverlay />
                            {type !== 'destination' && companyImage && (
                                <StyledCompanyLogoWrapper>
                                    <StyledCompanyLogo src={companyImage} />
                                </StyledCompanyLogoWrapper>
                            )}
                            <StyledStageWrapper
                                // I know 🙄
                                removePadding={device === 'tablet' && Boolean(highestDiscount)}
                            >
                                <StyledContentWrapper>
                                    {getCruiseStage(
                                        title,
                                        cruiseSearchFacets,
                                        type,
                                        pageTypeId,
                                        pageProps,
                                    )}
                                </StyledContentWrapper>
                            </StyledStageWrapper>
                        </NextImage>
                    </StyledBgWrapper>
                    <StyledCustomButtonWrapper>
                        <DreamlinesButton
                            primary
                            wrapperStyle={{
                                width: '100%',
                            }}
                            style={{
                                borderRadius: 0,
                                fontWeight: 600,
                                width: '100%',
                            }}
                            onClick={onSearchSubmit}
                        >
                            {formattedOfferCount}
                        </DreamlinesButton>
                    </StyledCustomButtonWrapper>
                </StyledSection>
            )}
        </>
    );
};

export default React.memo(React.forwardRef(LandingpageStageSearch));
